export default class ExtranetIncidentsIndex {
  constructor() {
      this.datatable = null;
      this.dataTableSearchHandler = null;
      this.currentFilter = 'all';
      this.defaultStatusFilter = ['Ouvert', 'En cours', 'En attente d\'infos', 'Résolu'];
      this.$table = $('#incidents-datatable');

      if (this.$table.length === 0) {
        return;
      }

      this.isNexloopInterne = this.$table.data('nexloop-interne');
      this.responsibleUrlTemplate = this.$table.data('responsible-url') || '';
      this.sourceUrl = this.$table.data('source-url');
      this.$loading = $('#incidents-loading');
      this.$tableWrapper = $('#incidents-table-wrapper');

      this.crit_select = $('.crit-select').selectpicker({ noneSelectedText: 'Criticitée' });
      this.cat_select = $('.cat-select').selectpicker({ noneSelectedText: 'Catégorie' });
      this.status_select = $('.status-select').selectpicker({ noneSelectedText: 'Statut' });

      this.bindFilterEvents();
      this.loadIncidentsData();
  }

  loadIncidentsData() {
    if (!this.sourceUrl) {
      this.$loading.html('<div class="alert alert-danger mb-0">URL de chargement des incidents introuvable.</div>');
      return;
    }

    fetch(this.sourceUrl, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      credentials: 'same-origin'
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Impossible de charger les incidents');
        }

        return response.json();
      })
      .then((payload) => {
        const rowsHtml = payload.rows_html || '';
        this.$table.find('tbody').html(rowsHtml);

        this.$loading.hide();
        this.$tableWrapper.show();

        this.initDatatable();
        this.bindEvents();
        this.applyDefaultStatusFilter();
      })
      .catch(() => {
        this.$loading.html('<div class="alert alert-danger mb-0">Erreur lors du chargement des incidents.</div>');
      });
  }

  bindEvents() {
    const self = this;
    
    const $el = $('#incidents-datatable');

    flatpickr("#maj_date_1, #maj_date_2, #c_date_1, #c_date_2", {
      locale: "fr",
      dateFormat: "d/m/Y",
      onChange: function () {
        $("#c_date_1_i").val($("#c_date_1").val());
        $("#c_date_2_i").val($("#c_date_2").val()); 
        $("#maj_date_1_i").val($("#maj_date_1").val());
        $("#maj_date_2_i").val($("#maj_date_2").val());
        
        self.datatable.draw();
      }
    });
    
    if (this.dataTableSearchHandler) {
      const previousHandlerIndex = $.fn.dataTable.ext.search.indexOf(this.dataTableSearchHandler);
      if (previousHandlerIndex !== -1) {
        $.fn.dataTable.ext.search.splice(previousHandlerIndex, 1);
      }
    }

    this.dataTableSearchHandler = function (settings, data, dataIndex) {
      if (settings.nTable !== $el.get(0)) {
        return true;
      }

      const row = self.datatable.row(dataIndex).node();
      
      // Apply incident ownership filter first
      if (!self.applyIncidentFilter(row)) {
        return false;
      }

      const crit = self.crit_select.val();
      const cat = self.cat_select.val();
      const status = self.status_select.val();
      const currentStatus = data[self.isNexloopInterne ? 8 : 7].replaceAll(/<[^>]*>/g, '').trim(); // Extract status from HTML

      const c_date_1 = flatpickr.parseDate($("#c_date_1").val(), "d/m/Y");
      const c_date_2 = flatpickr.parseDate($("#c_date_2").val(), "d/m/Y");
      
      const maj_date_1 = flatpickr.parseDate($("#maj_date_1").val(), "d/m/Y");
      const maj_date_2 = flatpickr.parseDate($("#maj_date_2").val(), "d/m/Y");

      // Apply default status filter when no status is explicitly selected
      if (status.length === 0 && !self.defaultStatusFilter.includes(currentStatus)) {
        return false;
      }
  
      if ((crit.length === 0 && cat.length === 0 && status.length === 0 && maj_date_1 === null && maj_date_2 === null && c_date_1 === null && c_date_2 === null)) {
        // Still apply default status filter
        return self.defaultStatusFilter.includes(currentStatus);
      }
  
      let critMatch = false;
      let catMatch = false;
      let statusMatch = false;
      let majDateMatch = false;
      let cDateMatch = false;
  
      if (crit.length === 0) {
        critMatch = true;
      } else {
        critMatch = crit.includes(data[2]); // Criticality
      }
  
      if (cat.length === 0) {
        catMatch = true;
      } else {
        catMatch = cat.includes(data[3]); // Category
      }
  
      if (status.length === 0) {
        statusMatch = self.defaultStatusFilter.includes(currentStatus);
      } else {
        statusMatch = status.includes(currentStatus);
      }

      if (c_date_1 === undefined && c_date_2 === undefined) {
        cDateMatch = true;
      } else {
        const c_date = flatpickr.parseDate(data[self.isNexloopInterne ? 6 : 5], "d/m/Y"); // Created_at

        if (c_date_1 !== undefined) {
          cDateMatch = c_date >= c_date_1;
        }
        if (c_date_2 !== undefined) {
          cDateMatch = c_date <= c_date_2;
        }
      
        if (c_date_1 !== undefined && c_date_2 !== undefined && c_date_2 >= c_date_1) {
          cDateMatch = c_date >= c_date_1 && c_date <= c_date_2;
        }
      }
      
      if (maj_date_1 === undefined && maj_date_2 === undefined) {
        majDateMatch = true;
      } else {
        const maj_date = flatpickr.parseDate(data[self.isNexloopInterne ? 7 : 6], "d/m/Y"); // Updated_at
       
        if (maj_date_1 !== undefined) {
          majDateMatch = maj_date >= maj_date_1;
        }
        if (maj_date_2 !== undefined) {
          majDateMatch = maj_date <= maj_date_2;
        }

        if (maj_date_1 !== undefined && maj_date_2 !== undefined && maj_date_2 >= maj_date_1) {
          majDateMatch = maj_date >= maj_date_1 && maj_date <= maj_date_2;
        }
      }

      return critMatch && catMatch && statusMatch && cDateMatch && majDateMatch;
    };

    $.fn.dataTable.ext.search.push(this.dataTableSearchHandler);
  
    $(".crit-select, .cat-select, .status-select").off('changed.bs.select.extranetIncidents').on('changed.bs.select.extranetIncidents', function () {
      self.datatable.draw();
    });

    // Export buttons functionality
    $("#export-csv").off('click.extranetIncidents').on('click.extranetIncidents', function() {
      self.datatable.button('.buttons-csv').trigger();
    });

    $("#export-excel").off('click.extranetIncidents').on('click.extranetIncidents', function() {
      self.datatable.button('.buttons-excel').trigger();
    });
  }

  bindFilterEvents() {
    const self = this;

    // Bind filter button events
    $('#filter-all').off('click.extranetIncidents').on('click.extranetIncidents', function() {
      self.setFilter('all');
    });

    $('#filter-my-incidents').off('click.extranetIncidents').on('click.extranetIncidents', function() {
      self.setFilter('my_incidents');
    });

    $('#filter-my-role-incidents').off('click.extranetIncidents').on('click.extranetIncidents', function() {
      self.setFilter('my_role_incidents');
    });
  }

  setFilter(filterType) {
    this.currentFilter = filterType;
    
    // Update button styles
    $('.btn-group button').removeClass('btn-primary').addClass('btn-outline-primary');
    $(`#filter-${filterType.replaceAll('_', '-')}`).removeClass('btn-outline-primary').addClass('btn-primary');
    
    // Redraw the datatable to apply the filter
    this.datatable.draw();
  }

  applyIncidentFilter(row) {
    const $row = $(row);
    const isMyIncident = $row.data('is-my-incident') === true;
    const isMyRoleIncident = $row.data('is-my-role-incident') === true;

    switch (this.currentFilter) {
      case 'my_incidents':
        return isMyIncident;
      case 'my_role_incidents':
        return isMyRoleIncident;
      case 'all':
      default:
        return true;
    }
  }
  
  applyDefaultStatusFilter() {
    // Pre-configure the status filter with default values
    this.status_select.selectpicker('val', this.defaultStatusFilter);
    // Refresh the selectpicker
    this.status_select.selectpicker('refresh');
    // Apply the filter
    this.datatable.draw();
  }
  
  initDatatable() {
    const self = this;
    const $el = $('#incidents-datatable');
    this.datatable = $el.DataTable({
      dom: 'Brtp',
      responsive: false,
      pageLength: 20,
      order: [[0, 'desc']],
      language: require('../../backoffice/utils/plugins/datatables_translation/'+I18n.locale+'.json'),
      buttons: [
        {
          extend: 'csvHtml5',
          text: 'Export CSV',
          className: 'd-none',
          filename: 'nexloop_incidents',
          exportOptions: {
            columns: ':visible'
          }
        },
        {
          extend: 'excelHtml5',
          text: 'Export Excel',
          className: 'd-none',
          filename: 'nexloop_incidents',
          exportOptions: {
            columns: ':visible'
          }
        }
      ],
      initComplete: function() {
        $(".dt-buttons").addClass("d-none");
      }
    });

    this.datatable.on('draw', () => {
      if (self.isNexloopInterne) {
        self.loadResponsibleNames();
      }
    });
  
    let $search = $('#customSearch');
  
    if ($search.length !== 0) {
      $search.off('keyup').on('keyup', function() {
        self.datatable.search($(this).val()).draw();
      });
    }
  }

  /**
   * Asynchronously load responsible names for all incidents in the table.
   * Uses batched AJAX calls to avoid blocking page load.
   * Each responsible cell shows a spinner placeholder until loaded.
   */
  loadResponsibleNames(rows = null) {
    const self = this;
    let $cells = rows
      ? $(rows).find('.responsible-cell')
      : $(self.datatable.rows({ page: 'current' }).nodes()).find('.responsible-cell');

    $cells = $cells.filter((_, cell) => !$(cell).data('responsible-loaded'));
    if ($cells.length === 0) return;

    const batchSize = 5;
    const cells = $cells.toArray();

    const loadBatch = (startIndex) => {
      const batch = cells.slice(startIndex, startIndex + batchSize);
      if (batch.length === 0) return;

      const promises = batch.map(cell => {
        const $cell = $(cell);
        const incidentId = $cell.data('incident-id');
        if (!incidentId) {
          $cell.find('.responsible-placeholder').html('--');
          $cell.data('responsible-loaded', true);
          return Promise.resolve();
        }

        const url = self.responsibleUrlTemplate.replace('%3Aid', incidentId).replace(':id', incidentId);

        return $.ajax({
          url: url,
          method: 'GET',
          dataType: 'json'
        }).then(data => {
          const name = data.name || '--';
          $cell.find('.responsible-placeholder').html(
            `<span class="responsible-name" title="${name}">${name}</span>`
          );
          $cell.data('responsible-loaded', true);
        }).catch(() => {
          $cell.find('.responsible-placeholder').html('--');
          $cell.data('responsible-loaded', true);
        });
      });

      Promise.all(promises).then(() => {
        if (startIndex + batchSize < cells.length) {
          loadBatch(startIndex + batchSize);
        }
      });
    };

    loadBatch(0);
  }

  onDataChanged(data) {
  }

  onDestroy() {
    if (this.datatable) {
      this.datatable.destroy();
    }

    if (this.dataTableSearchHandler) {
      const handlerIndex = $.fn.dataTable.ext.search.indexOf(this.dataTableSearchHandler);
      if (handlerIndex !== -1) {
        $.fn.dataTable.ext.search.splice(handlerIndex, 1);
      }
      this.dataTableSearchHandler = null;
    }

    $(".crit-select, .cat-select, .status-select").off('changed.bs.select.extranetIncidents');
    $('#filter-all').off('click.extranetIncidents');
    $('#filter-my-incidents').off('click.extranetIncidents');
    $('#filter-my-role-incidents').off('click.extranetIncidents');
    $('#export-csv').off('click.extranetIncidents');
    $('#export-excel').off('click.extranetIncidents');
    $('#customSearch').off('keyup');

    [this.crit_select, this.cat_select, this.status_select].forEach(select => {
      if (select && select.length) {
        select.selectpicker('destroy');
      }
    });

    $("#maj_date_1, #maj_date_2, #c_date_1, #c_date_2").each(function() {
      if (this._flatpickr) {
        this._flatpickr.destroy();
      }
    });
  }
}